import { z } from "zod";
import { IntlShape } from "react-intl";
import { EMAIL_REGEX, MAX_EMAILS } from "pages/admin-app/adminapp.constants";
import { splitEmails } from "pages/admin-app/utils/splitEmails";

export const getVendorFormSchema = (intl: IntlShape) => {
  return z.object({
    name: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.nameRequired" }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.nameRequired" }))
      .refine((val) => !val.includes(","), {
        message: intl.formatMessage({ id: "usAdmin.noCommasAllowed" }),
      }),
    contactName: z
      .string({
        required_error: intl.formatMessage({
          id: "usAdmin.contactNameRequired",
        }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.contactNameRequired" })),
    address: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.addressRequired" }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.addressRequired" })),
    city: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.cityRequired" }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.cityRequired" })),
    state: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.stateRequired" }),
      })
      .trim()
      .min(1, intl.formatMessage({ id: "usAdmin.stateRequired" }))
      .refine((val) => val !== "", {
        message: intl.formatMessage({ id: "usAdmin.stateRequired" }),
      }),
    countryId: z.number({
      required_error: intl.formatMessage({
        id: "usAdmin.countryRequired",
      }),
    }),
    zip: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.zipRequired" }),
      })
      .trim()
      .nonempty({ message: intl.formatMessage({ id: "usAdmin.zipRequired" }) }),
    phone: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.phoneRequired" }),
      })
      .trim()
      .nonempty({
        message: intl.formatMessage({ id: "usAdmin.phoneRequired" }),
      }),
    email: z
      .string({
        required_error: intl.formatMessage({ id: "usAdmin.emailRequired" }),
      })
      .trim()
      .nonempty(intl.formatMessage({ id: "usAdmin.emailRequired" }))
      .max(255, intl.formatMessage({ id: "usAdmin.emailTotalTooLong" }))
      .refine(
        (val) => {
          const emails = splitEmails(val);
          return emails.length <= MAX_EMAILS;
        },
        {
          message: intl.formatMessage({ id: "usAdmin.tooManyEmails" }),
        }
      )
      .refine(
        (val) => {
          const emails = splitEmails(val);
          return emails.every((e) => EMAIL_REGEX.test(e));
        },
        {
          message: intl.formatMessage({ id: "usAdmin.invalidEmail" }),
        }
      ),
    isId: z.number({
      required_error: intl.formatMessage({
        id: "usAdmin.industrySpecialistRequired",
      }),
    }),
  });
};

export type VendorFormData = z.infer<ReturnType<typeof getVendorFormSchema>>;
